export const CONTACT = {
  phones: ["+97142649406", "+971554539554"],
  address: "C1 AJM, BC1309264, Ajman, United Arab Emirates",
  addressAr: "C1 AJM، BC1309264، عجمان، الإمارات العربية المتحدة",
};

export const SERVICE_KEYS = ["feasibility", "investment", "consulting", "marketing"];

export const content = {
  en: {
    nav: { services: "Services", approach: "Approach", why: "Why Us", industries: "Industries", contact: "Contact", cta: "Book a consultation", menu: "Menu", close: "Close" },
    hero: {
      eyebrow: "Business & Investment Advisory — UAE",
      lines: ["Decisions", "built on", "evidence."],
      sub: "Stravion Advisory FZE helps businesses and investors move with clarity — through rigorous feasibility studies, investment studies, business consulting and marketing strategy.",
      primary: "Start a conversation",
      secondary: "Explore services",
      caption: "Ajman · United Arab Emirates",
      scroll: "Scroll",
    },
    marquee: ["Feasibility Studies", "Investment Studies", "Business Consulting", "Marketing Strategies", "Informed Decisions"],
    services: {
      eyebrow: "01 — Services",
      title: "Four disciplines. One standard of rigour.",
      enquire: "Enquire",
      items: {
        feasibility: { title: "Feasibility Studies", text: "Market, technical and financial feasibility that tells you whether — and how — an idea can stand on its own.", points: ["Market & demand analysis", "Technical & operational review", "Financial projections"] },
        investment: { title: "Investment Studies", text: "Structured analysis of opportunities, returns and risk so capital is committed with conviction.", points: ["Opportunity assessment", "Return & risk modelling", "Investor-ready reports"] },
        consulting: { title: "Business Consulting", text: "Practical guidance on strategy, structure and operations for companies starting, growing or repositioning.", points: ["Business planning", "Operating models", "Growth strategy"] },
        marketing: { title: "Marketing Strategies", text: "Positioning and go-to-market plans grounded in research, built to reach the right audience in the right market.", points: ["Market positioning", "Go-to-market planning", "Brand & channel strategy"] },
      },
    },
    approach: {
      eyebrow: "02 — Approach",
      title: "A deliberate path from question to decision.",
      steps: [
        { t: "Discover", d: "We define the question, your objectives and the constraints that matter." },
        { t: "Research", d: "We gather market, sector and financial data and test the assumptions behind it." },
        { t: "Analyse", d: "We model scenarios, returns and risk to reveal what the numbers really say." },
        { t: "Advise", d: "We deliver a clear recommendation and a strategy you can act on." },
      ],
    },
    why: {
      eyebrow: "03 — Why Stravion",
      quote: "Good strategy begins with an honest answer to a hard question.",
      items: [
        { t: "Independent perspective", d: "Objective analysis focused on your interests, not on a predetermined answer." },
        { t: "Rooted in the UAE", d: "Based in Ajman and focused on the realities of doing business in the region." },
        { t: "Evidence over opinion", d: "Every recommendation is traceable to data, assumptions and clear reasoning." },
        { t: "Built to be used", d: "Deliverables written for decision-makers, investors and lenders alike." },
      ],
    },
    industries: {
      eyebrow: "04 — Industries",
      title: "Sectors we advise across.",
      items: ["Real Estate & Development", "Hospitality & Tourism", "Healthcare", "Retail & Consumer", "Financial Services", "Trade & Logistics"],
    },
    contact: {
      eyebrow: "05 — Contact",
      title: "Let's make your next decision an informed one.",
      call: "Call us",
      visit: "Visit us",
      form: { name: "Full name", email: "Email address", phone: "Phone (optional)", service: "Service of interest", any: "General enquiry", message: "Tell us about your project", submit: "Send enquiry", sending: "Sending…" },
      ok: "Thank you — your enquiry has been received. We will be in touch shortly.",
      err: "Something went wrong. Please try again or call us directly.",
    },
    footer: { rights: "All rights reserved.", top: "Back to top" },
  },
  ar: {
    nav: { services: "الخدمات", approach: "منهجيتنا", why: "لماذا نحن", industries: "القطاعات", contact: "تواصل معنا", cta: "احجز استشارة", menu: "القائمة", close: "إغلاق" },
    hero: {
      eyebrow: "استشارات الأعمال والاستثمار — الإمارات",
      lines: ["قرارات", "مبنية على", "الدليل."],
      sub: "تساعد ستراڤيون للاستشارات (م.م.ح) الشركات والمستثمرين على التقدّم بوضوح — من خلال دراسات الجدوى، ودراسات الاستثمار، واستشارات الأعمال، والاستراتيجيات التسويقية.",
      primary: "ابدأ المحادثة",
      secondary: "استكشف الخدمات",
      caption: "عجمان · الإمارات العربية المتحدة",
      scroll: "مرّر",
    },
    marquee: ["دراسات الجدوى", "دراسات الاستثمار", "استشارات الأعمال", "الاستراتيجيات التسويقية", "قرارات مدروسة"],
    services: {
      eyebrow: "٠١ — الخدمات",
      title: "أربعة تخصصات. ومعيار واحد من الدقة.",
      enquire: "استفسر",
      items: {
        feasibility: { title: "دراسات الجدوى", text: "دراسات جدوى سوقية وفنية ومالية تبيّن ما إذا كانت الفكرة قابلة للنجاح — وكيف.", points: ["تحليل السوق والطلب", "المراجعة الفنية والتشغيلية", "التوقعات المالية"] },
        investment: { title: "دراسات الاستثمار", text: "تحليل منظّم للفرص والعوائد والمخاطر ليُستثمر رأس المال بثقة.", points: ["تقييم الفرص", "نمذجة العوائد والمخاطر", "تقارير جاهزة للمستثمرين"] },
        consulting: { title: "استشارات الأعمال", text: "توجيه عملي في الاستراتيجية والهيكلة والعمليات للشركات الناشئة والنامية.", points: ["خطط الأعمال", "نماذج التشغيل", "استراتيجية النمو"] },
        marketing: { title: "الاستراتيجيات التسويقية", text: "تموضع وخطط دخول للسوق مبنية على البحث، للوصول إلى الجمهور المناسب.", points: ["التموضع في السوق", "خطط دخول السوق", "استراتيجية العلامة والقنوات"] },
      },
    },
    approach: {
      eyebrow: "٠٢ — منهجيتنا",
      title: "مسار مدروس من السؤال إلى القرار.",
      steps: [
        { t: "الاكتشاف", d: "نحدّد السؤال وأهدافك والقيود المؤثرة." },
        { t: "البحث", d: "نجمع بيانات السوق والقطاع والبيانات المالية ونختبر الافتراضات." },
        { t: "التحليل", d: "نبني السيناريوهات ونقيس العوائد والمخاطر لنكشف ما تقوله الأرقام فعلاً." },
        { t: "التوصية", d: "نقدّم توصية واضحة واستراتيجية قابلة للتنفيذ." },
      ],
    },
    why: {
      eyebrow: "٠٣ — لماذا ستراڤيون",
      quote: "الاستراتيجية الجيدة تبدأ بإجابة صادقة عن سؤال صعب.",
      items: [
        { t: "رؤية مستقلة", d: "تحليل موضوعي يخدم مصلحتك، لا إجابة محسومة مسبقاً." },
        { t: "جذورنا في الإمارات", d: "مقرّنا في عجمان، ونركّز على واقع ممارسة الأعمال في المنطقة." },
        { t: "الدليل قبل الرأي", d: "كل توصية مستندة إلى بيانات وافتراضات ومنطق واضح." },
        { t: "مُعدّة للتنفيذ", d: "مخرجات مكتوبة لصنّاع القرار والمستثمرين والجهات المموّلة." },
      ],
    },
    industries: {
      eyebrow: "٠٤ — القطاعات",
      title: "القطاعات التي نقدّم فيها استشاراتنا.",
      items: ["العقارات والتطوير", "الضيافة والسياحة", "الرعاية الصحية", "التجزئة والمستهلك", "الخدمات المالية", "التجارة والخدمات اللوجستية"],
    },
    contact: {
      eyebrow: "٠٥ — تواصل معنا",
      title: "لنجعل قرارك القادم قراراً مدروساً.",
      call: "اتصل بنا",
      visit: "زورونا",
      form: { name: "الاسم الكامل", email: "البريد الإلكتروني", phone: "الهاتف (اختياري)", service: "الخدمة المطلوبة", any: "استفسار عام", message: "حدّثنا عن مشروعك", submit: "أرسل الاستفسار", sending: "جارٍ الإرسال…" },
      ok: "شكراً لك — تم استلام استفسارك وسنتواصل معك قريباً.",
      err: "حدث خطأ ما. يرجى المحاولة مجدداً أو الاتصال بنا مباشرة.",
    },
    footer: { rights: "جميع الحقوق محفوظة.", top: "إلى الأعلى" },
  },
};

export const SERVICE_IMAGES = { feasibility: "/img/exec.jpg", investment: "/img/finance.jpg", consulting: "/img/board.jpg", marketing: "/img/burj.jpg" };
export const INDUSTRY_IMAGES = ["/img/hero.jpg", "/img/hosp.jpg", "/img/health.jpg", "/img/retail.jpg", "/img/finance.jpg", "/img/logistics.jpg"];
